module.exports = __webpack_public_path__ + "static/media/progger3.8b794a36.png";